//
//
//
//
//
//
//
//
//
//
//

import FaqPopular from "~/components/pages/faq/FaqPopular";
import FaqThemes from "~/components/pages/faq/FaqThemes";
import FaqMyOrder from "~/components/pages/faq/FaqMyOrder";
import FaqNoQuestions from "~/components/pages/faq/FaqNoQuestions";
import staticPagesLang from "~/mixins/staticPagesLang";

export default {
    name: "HelpIndex",
    components: {
        FaqNoQuestions,
        FaqMyOrder,
        FaqThemes,
        FaqPopular,
    },
    middleware: ['fetch-dynamic-page-data'],
    mixins: [
        staticPagesLang
    ],
    head() {
        return {
            title: this.$t('static.faq.metaHelp.title'),
            meta: this.$t('static.faq.metaHelp.meta').map(el => {
                const data = {};
                for (let k in el){
                    data[k] = el[k]
                }
                data.hid = data.name || data.property || '';
                return data
            }),
        }
    },
    data() {
        return {
            popularList: null,
        }
    },
    async fetch() {
        await this.$axios.post(`${API.main}/widgets`, ['widget_items_list__automatic']).then((response) => {
            this.popularList = response.data['widget_items_list__automatic']
        })
    },
}
